<template>
  <div class="details">
    <Navigator />
    <!-- head -->
    <div class="head">
      <div>
        <h3>资讯动态</h3>
        <br />
        <p>Information trends</p>
      </div>
    </div>
    <!-- head -->
    <!-- content -->
    <div class="content">
      <!-- left -->
      <div class="left">
        <!-- 面包屑 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item><i class="el-icon-ship"></i></el-breadcrumb-item>
          <el-breadcrumb-item>资讯动态</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动列表</el-breadcrumb-item> -->
        </el-breadcrumb>
        <!-- 面包屑 -->
        <div class="gang"></div>
        <h3>{{ title }}</h3>
        <b>{{ time }}</b>
        <!-- <img :src="data[num].imgSrc1" alt="" class="imgSrc1" />
        <p v-html="data[num].text"></p>
        <img :src="data[num].imgSrc2" alt="" class="imgSrc2" />
        <p v-html="data[num].text1"></p>
        <img :src="data[num].imgSrc3" v-if="data[num].state" alt="" class="imgSrc2" />
        <p v-html="data[num].text2"></p> -->
        <div class="contentText" v-html="content"></div>
      </div>
      <!-- left -->
      <!-- right -->
      <div class="right">
        <!-- <h3>近期文章</h3>
        <template v-for="(item, i) in text">
          <a :key="i" @click="detailsFn(i)">{{ item.title }}</a>
        </template> -->
      </div>
      <!-- right -->
    </div>
    <!-- content -->
    <!-- footer -->
    <Footer />
    <!-- footer -->
  </div>
</template>
<script>
import { getNewDetailApi } from "@/api/new";
export default {
  data() {
    return {
      // data: [
      //   {
      //     state: true,
      //     imgSrc1: require("@/assets/img/news2.png"),
      //     imgSrc2: require("@/assets/img/news6.png"),
      //     imgSrc3: require("@/assets/img/news7.png"),
      //     h3: "江苏秀圆果公益助力《心灵之光-原生艺术作品展》",
      //     time: "2022-08-10",
      //     text: "走进“原生”，公益点亮你我。2022年8月7日，“心灵之光-原生艺术作品展”在江苏秀圆果科技有限公司展厅开幕。本次画展由南外高二学生徐辛耀及妹妹徐晓铭策划，江苏秀圆果科技有限公司作为协办单位，力邀著名摄影家汤一民作为展览顾问。展览汇集了八位南京艺术家32幅原生艺术画作，展示了他们独特而丰富的内心世界。<br>",
      //     text1:
      //       "南外高二学生徐辛耀7年前和妹妹徐筱铭在一次偶然机会中走进金陵图书馆的原生艺术作品展。这些由智力和精神障碍人士根据自己的本能所创作的精彩原生画作，深深触动了这对兄妹。7年后，为了让更多社会公众近距离感受原生艺术的力量，兄妹二人精心策划一场名为“心灵之光-原生艺术作品展”，我司董事长刘东兵先生了解到此次活动后，也特别想成人之美，给予这些“星星的孩子”展现自己的机会，提出无条件使用展厅及茶室。借此展鼓励原本自闭疏离的他们继续发挥才华与自信，更好地疗愈自我和融入社会，同时也希望他们的闪光之作能够照耀社会公众的心魄，赋予精神力量，呼吁社会给予他们多一点的理解和关爱。<br>“他们似乎与我们不同，难以沟通；他们似乎与我们隔断，无法交通。可当我们给他们一个机会，让他们拿起画笔，开始绘画，这隔墙上便开了窗、透了光、亮了。”<br>原生艺术：生命的裂痕，也是光照入之处<br>什么是原生艺术？展览顾问汤一民为大家作了详细介绍。所谓原生艺术，是指未受专业艺术训练的人根据自己的本能和天性自发创作的艺术。这是法国艺术家让·杜布菲在1945年首创的概念（Art Brut）。他搜集和研究精神病患者、自学者和儿童的艺术作品，认为这种摆脱了正统束缚的艺术形式更能真实地反映人类的精神世界。",
      //     text2:
      //       "因为社会大众对障碍人群的认识并不是系统与全面的，我司希望通过这次展览，让社会公众得以近距离欣赏这些纯净而灵性的独特画面，更充分地了解这些智力和精神障碍人士的艺术天赋，感受他们率真而自由的人性表达。也希望此展能够开一扇窗，让原本自闭疏离的他们，以如此触及灵魂的闪光之作，照耀我们的心魄，赋予精神的力量。让我们尽一份心、出一份力，给予他们多一点的理解和关爱，帮助他们改善条件、发挥才华和重建自信，更好地疗愈自我和融入社会。这是“双向”的心灵之光，是“互助”的心灵之光。",
      //   },
      //   {
      //     state: false,
      //     imgSrc1: require("@/assets/img/details2.2.png"),
      //     imgSrc2: require("@/assets/img/details2.1.png"),
      //     h3: "秀圆果科技携手江苏弘业股份有限公司，共同打造跨境新产品！",
      //     time: "2022-06-15",
      //     text: "近日，江苏弘业股份有限公司与江苏秀圆果信息科技有限公司达成战略合作。<br>江苏弘业股份有限公司成立于1979年，于1997年在上交所挂牌上市，是全国外贸工艺品行业和江苏省外贸系统第一家上市企业，现为江苏省苏豪控股集团有限公司重要成员企业，注册资本24676.75万元，先后通过了ISO9001质量管理体系、ISO14001环境管理体系和OHSAS18001职业健康安全管理体系认证，是“中国质量诚信企业”、“南京市总部企业”和“南京市外贸综合服务试点培育对象”，自主品牌“爱涛artall”连续多年荣获“江苏名牌产品”和“江苏省重点培育和发展的国际知名品牌”称号。<br> 双方就各自的发展现状、经营理念、投资策略和自身优势进行交流，并正式达成了战略合作共识。双方携手，将通过充分整合优势资源，创新模式，不断拓宽合作领域与合作思路，提升双方社会影响力，实现共同发展。",
      //   },
      //   {
      //     state: false,
      //     imgSrc1: require("@/assets/img/details3.2.png"),
      //     imgSrc2: require("@/assets/img/details3.1.jpg"),
      //     h3: "「转载」2019中国新经济人物评选:江苏秀圆果信息科技董事长刘东兵",
      //     time: "2022-06-15",
      //     text: "近几年，食品行业出现了一些严重的市场乱象，冒充知名品牌、冒充食品产地等问题让消费者苦不堪言。同时，由于消费者不知如何判断产品的真假好坏，导致的购买热度、 信任度下降， 也成为了很多食品行业、企业的痛点。近几年，国内不少企业利用物联网技术做出了一些尝试，刘东兵先生和他的团队便是其中的佼佼者。<br><br>食品安全是民生大计，自2011年商务部出台防伪溯源的行业标准，推广食品防伪、溯源体系建设以来，国内不少食品企业都进行了相关系统建设，以实现防伪、溯源、流通和市场的管控，保护企业品牌和知识产权，维护消费者的合法权益。<br><br>2014年，刘东兵先生针对洋河股份的防伪和追溯需求以及洋河酒的包装特点,设计开发了洋河防伪电子标签、标签编码及加密软件、现场采集应用系统、移动终端查验软件、防伪溯源设备监控软件等，并且全面应用到洋河酒厂的防伪追溯体系中，取得了较好的效果。<br><br>2017 年，刘东兵先生基于在食品溯源行业近5年的实施部署经验，针对茶行业存在严重的市场混乱现象，冒充知名品牌、冒充名山名寨等问题，建立了一套基于RFID技术和物联网技术的防伪溯源系统，为客户提供一体化的应用解决方案，秀圆果科技的这套技术方案已获国家专利认证。<br><br>区别于传统食品溯源常用的二维码信息易被复制破坏的特点， RFID技术感应更快速、使用寿命更长。同时，刘东兵先生率领的团队突破了RFID技术在生产过程中面临的高温高压的应用难点，让RFID电子内飞与茶饼完美结合，实现了从生产、加工、运输、仓储、门店及终端等环节，通过RFID技术层层把关，在全产业链中合理应用，让每饼茶“流传有序”。<br><br>据秀圆果科技的技术人员描述，当消费购买到带有“电子内飞”的茶饼时，只要将手机靠近茶饼或茶盒，听到“di…”的一声后，便可查看到溯源成功的产品信息。为打破靠一张嘴说故事的模式，茶叶品牌商“下关沱茶”与秀圆果科技合作开发，借助RFID物联网技术，让消费者知道了一饼茶的“前世今生”，并真实的、可视化的呈现给消费者。并且，带有“电子内飞”的茶品，将一直伴随着收藏者，去鉴证它的数十载历程和收藏价值。目前该方案已得到批量投产，并应用在了多个产品上。<br><br>从目前市场的发展现状来看，随着物联网、大数据、云计算、数字化、智能感知等技术的高速发展及移动终端设备的普及，RFID技术获得了全新的发展机遇。通过数字化技术，使包装变成真正的自媒体和万物互联的载体，将商品本身的性状及位置信息，以及原材料、生产、仓储、物流、销售、消费等全生命周期的数字信息以文字、图形、图像、动画、及音视频等可视化的方式，在包装盒体、终端设备或后台屏幕上实时显示出来，实现实时交互、处理、监控和决策的目的。智能包装利用各种技术，实现数据采集和大数据应用。对用户而言，可有效提升用户体验;对商家而言，十分有利于产品品牌提升，相信这项技术在未来生活大有可为。<br>",
      //   },
      // ],
      title: "",
      content: "",
      time: "",
      // text: [
      //   { title: "秀圆果召开商业计划书宣贯会议" },
      //   { title: "秀圆果科技携手江苏弘业股份有限公司，共同打造跨境新产品！" },
      //   { title: "紧密跟进物联网追溯的市场机遇" }
      // ],
    };
  },
  async created() {
    await this.detailFn();
  },
  methods: {
    async detailFn() {
      let i = sessionStorage.getItem("details");
      let res = await getNewDetailApi(i);
      this.content = res.data.content;
      this.title = res.data.title;
      this.time = res.data.publishTime;
    },
  },
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 750px) {
  ::v-deep .contentText {
    img {
      width: 17.15rem;
    }
    p {
      font-size: 0.6rem;
      font-weight: 400;
      color: #000000;
      line-height: 1rem;
      margin: 0.67rem 0;
      font-family: "微软雅黑";
    }
  }
  .details {
    height: 100%;
    width: 100%;
    .head {
      height: 8rem;
      background: url(../../../assets/img/news-bj.png) no-repeat;
      background-size: 100% 100%;
      overflow: hidden;
      text-align: center;
      h3 {
        margin-top: 4.35rem;
        font-size: 1.02rem;
        font-family: HarmonyOS Sans-Bold, HarmonyOS Sans;
        font-weight: bold;
        color: #ffffff;
        line-height: 1.18rem;
        text-shadow: 0px 1px 1px rgba(108, 108, 108, 0.25);
      }
      p {
        font-size: 0.41rem;
        font-family: HarmonyOS Sans-Bold, HarmonyOS Sans;
        font-weight: bold;
        color: #ffffff;
        line-height: 0.82rem;
        text-shadow: 0px 1px 1px rgba(108, 108, 108, 0.25);
      }
    }
    .content {
      width: 17.15rem;
      margin: auto;
      .left {
        margin-bottom: 1rem;
        .el-breadcrumb,
        .gang {
          display: none;
        }
        h3 {
          margin: 0.92rem 0 0.61rem;
          font-size: 0.82rem;
          font-family: HarmonyOS Sans-Regular, HarmonyOS Sans;
          font-weight: 400;
          color: #000000;
          line-height: 0.82rem;
        }
        b {
          display: block;
          margin-bottom: 0.67rem;
          font-size: 0.61rem;
          font-family: HarmonyOS Sans-Regular, HarmonyOS Sans;
          font-weight: 400;
          color: #606060;
        }

        // .imgSrc2 {
        //   width: 17.15rem;
        //   height: 8.96rem;
        // }
      }
      .right {
        h3 {
          line-height: 1.79rem;
          font-size: 0.72;
          font-family: HarmonyOS Sans-Bold, HarmonyOS Sans;
          font-weight: bold;
          color: #2e2e2e;
        }
        a {
          display: block;
          font-size: 0.61rem;
          font-family: HarmonyOS Sans-Regular, HarmonyOS Sans;
          font-weight: 400;
          color: #000000;
          line-height: 1.43rem;
        }
      }
    }
  }
}
@media only screen and (max-width: 19200px) and (min-width: 751px) {
  ::v-deep .contentText {
    img {
      width: 9.44rem;
      margin-top: 0.27rem;
    }
    p {
      font-size: 0.25rem;
      font-weight: 500;
      color: #000000;
      line-height: 0.4rem;
      font-family: "微软雅黑";
      margin: 0.36rem 0;
    }
  }
  .details {
    height: 100%;
    width: 100%;
    position: relative;
    .head {
      text-align: center;
      height: 5.48rem;
      overflow: hidden;
      background: url(../../../assets/img/news-bj.png) no-repeat;
      background-size: 100% 100%;
      div {
        margin: auto;
        width: 13rem;
        color: #fff;
        font-family: PingFang SC-Heavy, PingFang SC;
        h3 {
          font-size: 1rem;
          margin-top: 2rem;
        }
        p {
          font-size: 0.4rem;
        }
      }
    }
    // content
    .content {
      width: 14rem;
      height: 100%;
      margin: auto;
      .left {
        width: 9.5rem;
        float: left;
        .el-breadcrumb {
          margin: 0.49rem 0 0.78rem;
          height: 0.42rem;
          font-size: 0.3rem;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #2f2f2f;
          line-height: 0.35rem;
        }
        .gang {
          width: 0.8rem;
          height: 0.1rem;
          background-color: #093c7f;
          margin-bottom: 0.05rem;
        }
        h3 {
          // width: 7rem;
          // height: 0.7rem;
          font-size: 0.5rem;
          font-family: PingFang SC-Heavy, PingFang SC;
          font-weight: 800;
          color: #2f2f2f;
          line-height: 0.59rem;
        }
        b {
          width: 9.5rem;
          height: 0.4rem;
          font-size: 0.24rem;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #606060;
          line-height: 0.28rem;
          display: block;
          border-bottom: 0.01rem solid #ccc;
        }
      }
      .right {
        float: right;
        width: 3.6rem;
        h3 {
          font-size: 0.3rem;
          font-family: PingFang SC-Heavy, PingFang SC;
          font-weight: 800;
          color: #2f2f2f;
          line-height: 0.42rem;
          margin: 2.9rem 0 0.14rem;
        }
        a {
          display: block;
          width: 3.6rem;
          font-size: 0.24rem;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 0.34rem;
          margin-top: 0.2rem;
        }
      }
    }
  }
}
</style>
